import React, { Component } from 'react';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import PhuChart from './phu-graph';
import PhuStatusGraph from './phu-StatusGraph';
import PhuStatusTable from './phu-StatusTable';
import PhuTable from './phu-table';
import trans from '../../translations.json';
import GraphMetric from './GraphMetric';
import dict from '../../dictionary';
import Tabs from '../tabs/tabs';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const metric = {
  new: 'new',
  active: 'active',
  resolved: 'resolved',
};

class PhuIndex extends Component {
  state = {
    selectedViewMode: viewModes.graph,
    selectedMetric: metric.new,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  changeMetric = (newMetric) => {
    this.setState({
      selectedMetric: newMetric,
    });
  };

  render() {
    let Phuchart = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <Tabs
                lang={this.props.lang}
                newCases={
                  <>
                    <GetRightDesc />
                    <ButtonGroup
                      selected={this.state.selectedViewMode}
                      viewModes={viewModes}
                      lang={this.props.lang}
                      handleOnClick={this.onViewModeChange}
                    />
                    <PhuChart
                      selectedTab="newCases"
                      lang={this.props.lang}
                      chartTitle={trans.phu.title[this.props.lang]}
                    />
                  </>
                }
                totalCases={
                  <>
                    <GetRightDesc />
                    <ButtonGroup
                      selected={this.state.selectedViewMode}
                      viewModes={viewModes}
                      lang={this.props.lang}
                      handleOnClick={this.onViewModeChange}
                    />
                    <PhuChart
                      selectedTab="totalCases"
                      lang={this.props.lang}
                      chartTitle={trans.phu.title[this.props.lang]}
                    />
                  </>
                }
              />
            </>
          );
        case viewModes.table:
          return (
            <>
              <Tabs
                lang={this.props.lang}
                newCases={
                  <>
                    <GetRightDesc />
                    <ButtonGroup
                      selected={this.state.selectedViewMode}
                      viewModes={viewModes}
                      lang={this.props.lang}
                      handleOnClick={this.onViewModeChange}
                    />
                    <PhuTable
                      selectedTab="newCases"
                      lang={this.props.lang}
                    />
                  </>
                }
                totalCases={
                  <>
                    <GetRightDesc />
                    <ButtonGroup
                      selected={this.state.selectedViewMode}
                      viewModes={viewModes}
                      lang={this.props.lang}
                      handleOnClick={this.onViewModeChange}
                    />
                    <PhuTable
                      selectedTab="totalCases"
                      lang={this.props.lang}
                    />
                  </>
                }
              />
            </>
          );
        default:
      }
    };

    let Activechart = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusGraph
                field="ACTIVE_CASES"
                selectedTab="newCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
              />
              {/* <Tabs
              lang={this.props.lang}
              newCases={
                <>
                <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuActiveChart
                selectedTab="newCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
                />
              </>
                
              } */}
              {/* totalCases={
                <>
                <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuActiveChart
                selectedTab="totalCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
                />
              </>
                
              }
            /> */}
            </>
          );
        case viewModes.table:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusTable
                field="ACTIVE_CASES"
                selectedTab="newCases"
                lang={this.props.lang}
              />
              {/* <Tabs
              lang={this.props.lang}
              newCases={
                <>
                <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuActiveTable
                  selectedTab="newCases"
                  lang={this.props.lang}
                />
              </>
                
              }
              totalCases={
                <>
                <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuActiveTable
                  selectedTab="totalCases"
                  lang={this.props.lang}
                />
              </>
                
              }
            /> */}
            </>
          );
        default:
      }
    };

    let Resolvedchart = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusGraph
                field="RESOLVED_CASES"
                selectedTab="newCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
              />
              {/* <Tabs
              lang={this.props.lang}
              newCases={
              <>
              <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuResolvedChart
                selectedTab="newCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
                />
              </>
                
              }
              totalCases={
                <>
                <GetRightDesc />
              <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuResolvedChart
                selectedTab="totalCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
                />
              </>
                
              }
            /> */}
            </>
          );
        case viewModes.table:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusTable
                field="RESOLVED_CASES"
                selectedTab="newCases"
                lang={this.props.lang}
              />
              {/* <Tabs
              lang={this.props.lang}
              newCases={
                <> 
                <GetRightDesc />
                <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuResolvedTable
                  selectedTab="newCases"
                  lang={this.props.lang}
                />
                </>
                
              }
              totalCases={
                <>
                <GetRightDesc />
                <ButtonGroup
                  selected={this.state.selectedViewMode}
                  viewModes={viewModes}
                  lang={this.props.lang}
                  handleOnClick={this.onViewModeChange}
                />
                <PhuResolvedTable
                  selectedTab="totalCases"
                  lang={this.props.lang}
                />
                </>
              }
            /> */}
            </>
          );
        default:
      }
    };
    let Deathchart = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusGraph
                field="DEATHS"
                selectedTab="newCases"
                lang={this.props.lang}
                chartTitle={trans.phu.title[this.props.lang]}
              />
            </>
          );
        case viewModes.table:
          return (
            <>
              <GetRightDesc />
              <ButtonGroup
                selected={this.state.selectedViewMode}
                viewModes={viewModes}
                lang={this.props.lang}
                handleOnClick={this.onViewModeChange}
              />
              <PhuStatusTable
                field="DEATHS"
                selectedTab="newCases"
                lang={this.props.lang}
              />
            </>
          );
        default:
      }
    };

    const GetRightView = () => {
      switch (this.state.selectedMetric) {
        case dict.new:
          return <Phuchart />;
        case dict.NotResolved:
          return <Activechart />;
        case dict.resolved:
          return <Resolvedchart />;
        case dict.deaths:
          return <Deathchart />;
        default:
          return <Phuchart />;
      }
    };

    const GetRightDesc = () => {
      switch (this.state.selectedMetric) {
        case dict.new:
          return (
            <p>
              {trans.phu.dailyPHU[this.props.lang]}{' '}
              <a href="#time-lag" rel="noopener">
                {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
              </a>
            </p>
          );
        case dict.NotResolved:
          return (
            <p>
              {trans.phu.activePHU[this.props.lang]}{' '}
              <a href="#time-lag" rel="noopener">
                {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
              </a>
            </p>
          );
        case dict.resolved:
          return (
            <p>
              {trans.phu.resolvedPHU[this.props.lang]}{' '}
              <a href="#time-lag" rel="noopener">
                {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
              </a>
            </p>
          );
        case dict.deaths:
          return (
            <p>
              {trans.phu.deathsPHU[this.props.lang]}{' '}
              <a href="#time-lag" rel="noopener">
                {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
              </a>
            </p>
          );
        default:
          return (
            <p>
              {trans.phu.dailyPHU[this.props.lang]}{' '}
              <a href="#time-lag" rel="noopener">
                {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
              </a>
            </p>
          );
      }
    };

    return (
      <div id="">
        <>
          <GraphMetric
            lang={this.props.lang}
            setMetric={this.changeMetric}
            metric={this.state.selectedMetric}
          />
          <GetRightView />
        </>
      </div>
    );
  }
}
export default PhuIndex;
